// import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import '@fortawesome/fontawesome-free/css/all.min.css';
import "./Header.css";

const Header = () => {

const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
      setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
      setMenuOpen(false);
    };
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDropdown = (name) => {
    if (window.innerWidth > 768) return; 
    setActiveDropdown(activeDropdown === name ? null : name);
  };
  

const [openDropdown, setOpenDropdown] = useState(false);
  return (
    <header className="header">
      <div className="top-bar">

        {/* LOGO */}
        <div className="logo">
          <Link to="/">
            <img src="/logo/Swastika-logo.png" alt="swastika logo" />
          </Link>
        </div>

        {/* HAMBURGER */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV */}
        <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>

          {/* ABOUT US */}
          <div
            className={`nav-item ${activeDropdown === "about" ? "open" : ""}`}
            onClick={() => handleDropdown("about")}
          >
            <span>
              About Us <i className="fa fa-chevron-down" style={{color: "#2d4599"}}></i>
            </span>

            <div className="mega-menu">
              <div className="mega-content">
                <div className="menu-left">

                  <div className="menu-col career-col">
                    <h4>The Swastika Infra </h4>
                    <Link to="/about" onClick={closeMenu}>Overview</Link>
                    <Link to="/vision" onClick={closeMenu} >Vision & Mission</Link>
                    <Link to="/presence" onClick={closeMenu}>Presence</Link>
                    <Link to="/csr" onClick={closeMenu}>CSR</Link>
                    {/* <Link to="/disclaimer" >Disclaimer</Link> */}
 
                  </div>

                  <div className="menu-col career-col">
                    <h4>Leadership</h4>
                    <Link to="/Corporate/BM" onClick={closeMenu}>Board Of Directors</Link>
                    <Link to="/Corporate/SM" onClick={closeMenu}>Senior Management</Link>
                    <a href="/PDF/Board-Committees.pdf" target="_blank" rel="noopener noreferrer"> Board Committee </a>
                    <Link to="/Corporate/MD" onClick={closeMenu}>Message from MD</Link>

                  </div>

                   <div className="menu-col career-col">
                    <h4>Gallery</h4>
                    <Link to="/award" onClick={closeMenu} >Awards & Recognition</Link>
                   

                  </div>

                  

                </div>
                <div className="menu-right">
                  <img src="./images/About Us.jpg" alt="" />
                  {/* <Link to="/about" onClick={closeMenu}>
                    <button>INTRODUCTION</button>
                  </Link> */}
                </div>
              </div>
            </div>
          </div>

          {/* BUSINESSES */}
          <div
            className={`nav-item ${activeDropdown === "business" ? "open" : ""}`}
            onClick={() => handleDropdown("business")}
          >
            <span>Businesses <i className="fa fa-chevron-down" style={{color: "#2d4599"}}></i></span>

            <div className="mega-menu">
              <div className="mega-content">
                <div className="menu-left">

                   {/* <div className="menu-col career-col">
                    
                      <h4>Services</h4>
                      <Link to="/Service/Transmission" onClick={closeMenu}>Transmission</Link>
                      
                    
                      <h4>Distribution</h4>
                     
                      <Link to="/Service/Cable" onClick={closeMenu}>Underground Cabling</Link>
                      <Link to="/Service/Electric" onClick={closeMenu}>Rural Electrification</Link>
                      <Link to="/Service/Sub" onClick={closeMenu}>Substations</Link>
                      <Link to="/Service/Light" onClick={closeMenu}>Street Lighting</Link>
                    
                   
                  </div> */}
                  <div className="menu-col career-col">

  <h4>Services</h4>
  <Link to="/Service/Transmission" onClick={closeMenu}>Transmission</Link>

  {/* DROPDOWN TITLE */}
  <Link 
    onClick={() => setOpenDropdown(!openDropdown)} 
    className="dropdown-title"
  >
    Distribution   
  </Link>

  {/* DROPDOWN ITEMS */}
  {openDropdown && (
    <div className="dropdown-content">
      <Link to="/Service/Cable" onClick={closeMenu}>Underground Cabling</Link>
      <Link to="/Service/Electric" onClick={closeMenu}>Rural Electrification</Link>
      <Link to="/Service/Sub" onClick={closeMenu}>Substations</Link>
      <Link to="/Service/Light" onClick={closeMenu}>Street Lighting</Link>
    </div>
  )}

</div>

                  <div className="menu-col career-col">
                   
                      <h4>Projects</h4>
                      
                      <Link to="/projects/#current" onClick={closeMenu}>Ongoing Projects</Link>
                      <Link to="/projects/#complete" onClick={closeMenu}>Completed Projects</Link>
                   
                  </div>

                  <div className="menu-col career-col">

                    <div>
                      <h4>Why Us?</h4>
                      <Link to="/why-us" onClick={closeMenu}>Why Swastika Infra</Link>
                    </div>
                  </div>

                </div>
                <div className="menu-right">
                  <img src="/images/business.jpg" alt="" />
                  {/* <Link to="/about" onClick={closeMenu}>
                    <button>INTRODUCTION</button>
                  </Link> */}
                </div>

              </div>
            </div>
          </div>

          {/* INVESTORS */}
              <div
            className={`nav-item ${activeDropdown === "investor" ? "open" : ""}`}
            onClick={() => handleDropdown("investor")}
          >
            <span>Investor Relation <i className="fa fa-chevron-down" style={{color: "#2d4599"}}></i></span>

            <div className="mega-menu">
              <div className="mega-content">
                <div className="menu-left">

                  <div className="menu-col career-col">

                    <h4>Shareholders </h4>
                    <Link to="/investor/shareholding-pattern"  onClick={closeMenu} >Shareholding Pattern</Link>
                                                   
                    <h4>Document</h4>
                    <Link to="/investor/ipo"  onClick={closeMenu} >IPO </Link>
                    <Link to="/investor/materialcontracts"  onClick={closeMenu} >Material Contracts & Material Documents </Link>
                    
                   
                  </div>

                  <div className="menu-col career-col">    

                    <h4>Reports </h4>
                    <Link to="/investor/annual-report" onClick={closeMenu} >Annual Reports </Link>
                    <Link to="/investor/annual-return" onClick={closeMenu} >Annual Return</Link>
                    <Link to="/investor/industry-report" onClick={closeMenu} >Industry Report </Link>
                    
                    <h4>Group Companies </h4>
                    <Link to="/investor/group-companies" onClick={closeMenu} >Group Companies </Link>
                  </div>


                  <div className="menu-col career-col">

                    <h4>Policies</h4>
                    <Link to="/investor/policies" onClick={closeMenu} >Policies </Link>
                    
                    <h4>Grievances </h4>
                    <Link to="/investor/investor-grievance-contact" onClick={closeMenu} >Investor Grievances </Link>
                  </div>

                  

                </div>
                <div className="menu-right">
                 <img src="./images/Investor Relation.jpg" alt="" />
                  {/* <Link to="/about" onClick={closeMenu} >
                    <button>INTRODUCTION</button>
                  </Link> */}
                </div>
              </div>
            </div>
          </div>

          {/* CONTACT */}
          <div
            className={`nav-item ${activeDropdown === "contact" ? "open" : ""}`}
            onClick={() => handleDropdown("contact")}
          >
            <span>Connect <i className="fa fa-chevron-down" style={{color: "#2d4599"}}></i></span>

            <div className="mega-menu">
              <div className="mega-content">
                <div className="menu-left">

                   <div className="menu-col career-col">
                    <h4>Social Media</h4>
                    <Link to="https://www.facebook.com/photo/?fbid=122103954530821937&set=a.122103954656821937" onClick={closeMenu}>Facebook</Link>
                    <Link to="https://www.instagram.com/swastika.infra/" onClick={closeMenu}>Instagram</Link>
                    <Link to="https://www.linkedin.com/in/swastika-infra-limited-68067a398/" onClick={closeMenu}>LinkedIn</Link>
                    <Link to="https://www.youtube.com/@SwastikaInfraLimited-z9c" onClick={closeMenu}>YouTube</Link>
                  </div>

                 

                  <div className="menu-col career-col">
                    <h4>Connect</h4>
                    <Link to="/contact" onClick={closeMenu}>Contact Us</Link>
                    <Link to="/query" onClick={closeMenu}>Send Your Query</Link>
                  </div>

                   <div className="menu-col career-col">
                    <h4>Career</h4>
                    <Link to="/career">Join Our Team</Link>
                    {/* <Link to="/career/#benefits">Why Join Us</Link> */}

                    {/* <h4>Location</h4> */}
                  </div>

                </div>

                <div className="menu-right">
                 <img src="./images/Contact.jpg" alt="" />
                  {/* <Link to="/contact" onClick={closeMenu}>
                   <button>CONTACT</button>  
                  </Link> */}
                </div>
              </div>
            </div>
          </div>

        </nav>
      </div>
    </header>
  );
};

export default Header;
